export let ENV = "production";
ENV = "";

export const API_URL =
  ENV === "production" ? "/api" : "https://godspan.com.py/api";
